// Rechtliche Verweise und Hinweistexte, an einer Stelle für Erfassung,
// Business-App und Bericht. Die Seiten selbst liegen statisch in
// rechtliches/ und werden von Caddy auf umzugsscan.app, scan. und app.
// unter denselben Pfaden ausgeliefert (betrieb/umzugsscan.caddy).

export const RECHT_BASIS_URL = "https://umzugsscan.app";
export const IMPRESSUM_URL = `${RECHT_BASIS_URL}/impressum`;
export const DATENSCHUTZ_URL = `${RECHT_BASIS_URL}/datenschutz`;
export const AVV_URL = `${RECHT_BASIS_URL}/avv`;
/** AGB-Entwürfe (08.10.2026): Firmen und Verbraucher getrennt. */
export const AGB_URL = `${RECHT_BASIS_URL}/agb`;
export const AGB_VERBRAUCHER_URL = `${RECHT_BASIS_URL}/agb-verbraucher`;

/**
 * Privat-Aufnahme: ausdrückliches Verlangen der sofortigen Ausführung und
 * Kenntnis vom Verlust des Widerrufsrechts (§ 356 Abs. 4 und 5 BGB).
 */
export const WAIVER_TEXT =
  "Ich verlange ausdrücklich, dass Umzugsscan sofort nach der Zahlung mit der Auswertung beginnt. " +
  "Mir ist bekannt, dass ich mein Widerrufsrecht verliere, sobald die Auswertung vollständig erbracht ist.";

/** Kennzeichnung der KI-Auswertung im Bericht (App, HTML, PDF). */
export const KI_HINWEIS =
  "KI-gestützte Auswertung: Möbel, Mengen, Volumen und Gewicht wurden automatisch aus den Fotos des Kunden geschätzt. " +
  "Die Werte sind eine Planungshilfe und vom Umzugsunternehmen zu prüfen.";

/** Hinweis vor dem ersten Foto in der Erfassung. */
export function photoNoticeText(retentionDays: number): string[] {
  return [
    "Ihre Fotos werden für die Planung Ihres Umzugs mit Hilfe künstlicher Intelligenz (KI) ausgewertet. " +
      "Dabei werden Möbel erkannt und das Umzugsvolumen geschätzt.",
    `Die Fotos werden ${retentionDays === 1 ? "einen Tag" : `${retentionDays} Tage`} nach dem Absenden automatisch gelöscht.`,
    "Bitte fotografieren Sie keine Personen, keine Ausweise und keine Dokumente oder Briefe.",
  ];
}

export const PHOTO_NOTICE_LABEL = "Ich habe den Hinweis gelesen.";

/** Startschritt (12.10.2026): Fotohinweis steht dort, die Bestätigung hängt an der Pflicht-Einwilligung. */
export const PHOTO_NOTICE_IN_CONSENT = "Den Hinweis zu den Fotos habe ich gelesen.";
